import MasterLayout from "../components/layouts/MasterLayout";
import MainSearch from "../components/search/MainSearch";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { CLEAR_SHOW_MORE_PRODUCT_LIST, FETCH_PRODUCT_LIST, FETCH_SHOW_MORE_PRODUCT_LIST } from "../redux/actions";
import ShowMoreProductList from "../components/products/ShowMoreProductList";
import { useDebounce } from "../helpers";

const ShowMoreProductPage = () => {

    const dispatch = useDispatch();
    const { showMoreProductData } = useSelector((state) => state.showMoreProductData);
    const selectedId = useSelector((state) => state.selectItemDrawerMenu.selectedId);
    const currentPage = useSelector((state) => state.currentPage.currentPage);
    const state = useSelector((state) => state);
    const { productData } = state.productData;
    const { freeCheckbox } = state;
    const { selectSpace } = state.selectSpace
    const { selectColor } = state.selectColor
    const { searchInputContent } = state.searchInputContent


    const debouncedSearchContent = useDebounce(searchInputContent, 500);


    useEffect(() => {
        dispatch({ type: CLEAR_SHOW_MORE_PRODUCT_LIST });
        dispatch({ type: FETCH_SHOW_MORE_PRODUCT_LIST });
    }, [selectedId, freeCheckbox, dispatch, selectSpace, selectColor , debouncedSearchContent, currentPage]);

    return (
        <MasterLayout>
            <MainSearch />
            <ShowMoreProductList data={showMoreProductData} status={'product'} />
        </MasterLayout>
    )
}


export default ShowMoreProductPage
